import { Grid, LinearProgress, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";

export const LinearLoader = () => {
  const [progress, setProgress] = useState(0);
  const [buffer, setBuffer] = useState(10);

  const progressRef = useRef(() => { });

  useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Grid container sx={{ justifyContent: "center", alignItems: 'center', m: '0.5rem auto', minHeight: '65px' }}>
      <Grid item xs={5}>
        <LinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
        <Typography color='primary' sx={{ fontSize: '14px', textAlign: 'center' }}>Loading 3D Experience...</Typography>
      </Grid>
    </Grid>
  )
}